var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName:
                                "v-permission:SettingGoodsAuditStrategyIndex_Save",
                              arg: "SettingGoodsAuditStrategyIndex_Save",
                            },
                          ],
                          attrs: { type: "primary", loading: _vm.loading },
                          on: { click: _vm.confirm },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.loading
                                  ? _vm.$t("savingText")
                                  : _vm.$t("saveText")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(_vm._s(_vm.$t("ProductAuditStrategy.top.SKUreview")) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ProductAuditStrategy.top.Create") } },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.createdAuditStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "createdAuditStatus", $$v)
                  },
                  expression: "form.createdAuditStatus",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ProductAuditStrategy.top.Modify") } },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.updateAuditStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "updateAuditStatus", $$v)
                  },
                  expression: "form.updateAuditStatus",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.updateAuditStatus,
                  expression: "form.updateAuditStatus",
                },
              ],
              staticStyle: { "margin-left": "15px" },
              attrs: { label: _vm.$t("ProductAuditStrategy.top.Trigger") },
            },
            [
              _c("el-checkbox", {
                attrs: {
                  label: _vm.$t("ProductAuditStrategy.top.price"),
                  "true-label": 1,
                  "false-label": 0,
                },
                model: {
                  value: _vm.form.updatePriceStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "updatePriceStatus", $$v)
                  },
                  expression: "form.updatePriceStatus",
                },
              }),
              _c("el-checkbox", {
                attrs: {
                  label: _vm.$t("ProductAuditStrategy.top.attribute"),
                  "true-label": 1,
                  "false-label": 0,
                },
                model: {
                  value: _vm.form.updatePropertyStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "updatePropertyStatus", $$v)
                  },
                  expression: "form.updatePropertyStatus",
                },
              }),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(
              _vm._s(_vm.$t("ProductAuditStrategy.middle.synchronization"))
            ),
          ]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ProductAuditStrategy.middle.information"),
              },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.uploadSkuThirdStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "uploadSkuThirdStatus", $$v)
                  },
                  expression: "form.uploadSkuThirdStatus",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("ProductAuditStrategy.middle.classification"),
              },
            },
            [
              _c("el-switch", {
                attrs: { "active-value": 1, "inactive-value": 0 },
                model: {
                  value: _vm.form.uploadCategoryThirdStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "uploadCategoryThirdStatus", $$v)
                  },
                  expression: "form.uploadCategoryThirdStatus",
                },
              }),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("ProductAuditStrategy.bottom.shelf"))),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ProductAuditStrategy.bottom.Open") } },
            [
              _c("el-switch", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.form.todo,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "todo", $$v)
                  },
                  expression: "form.todo",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }